import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken as FGetToken,
  MessagePayload,
  onMessage,
} from "firebase/messaging";
import debouce from "lodash/debounce";

const firebaseConfig = {
  apiKey: "AIzaSyB2ldCJ-FubOzTXOzapBaf4JPqisXSp-yA",
  authDomain: "vnlottery-671c3.firebaseapp.com",
  projectId: "vnlottery-671c3",
  storageBucket: "vnlottery-671c3.firebasestorage.app",
  messagingSenderId: "674263040865",
  appId: "1:674263040865:web:b679e293df212bcad87b20",
  measurementId: "G-RSQ7JQQ6N3",
};

const msgKey =
  "BOmcf-S4-RiZGNigMdkkRGDLLwykmDfMJqlyBKzO0C9q0EadJEkD7H1H9zApLio8MJEu9pNxSeWgIFDEkgZ1jnU";

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

export const getToken = async (): Promise<string | null> => {
  try {
    let currentToken = await FGetToken(messaging, { vapidKey: msgKey });
    if (currentToken) {
      console.log("current token for client: ", currentToken);
      return currentToken;
    } else {
      console.log(
        "No registration token available. Request permission to generate one."
      );
      return null;
    }
  } catch (error) {
    console.log("An error occurred while retrieving token. ", error);
    throw error;
  }
};

export const onMessageListener = (
  cb: (data: MessagePayload) => void
): Promise<MessagePayload> =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      cb(payload);
      debouncedPlaySound();
      resolve(payload);
    });
  });

function playSound() {
  var audio = new Audio("/audio/new-order.mp3");
  audio.play();
}

// Usage:
// This will create a debounced version of the playSound function
// that, when called repeatedly, will only actually invoke playSound
// at most once every 1 second.
var debouncedPlaySound = debouce(() => {
  playSound();
}, 1000);
